import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["priority", "option", "input"]

  connect() {
    console.log("priority connect")

    // this.tabTargets[0].toggleTransition()
  }

  // Zmiana priorytetu ma dwa warianty w zależności od typu ikony (wykrywamy z DOM):
  // - GWIAZDKA (mail/kb) ma element `.priority-border` - kształt stały, zmieniamy kolor
  //   i przełączamy obwódkę dla kolorów "-full" (jak w oryginale).
  // - CHEVRON (zadanie) nie ma obwódki - kształt zależy od poziomu, więc oprócz koloru
  //   kopiujemy ścieżki SVG z klikniętej opcji.
  changePriority(event) {
    const svg = this.priorityTarget.querySelector("svg")
    const oldColor = this.priorityTarget.dataset.currentColor || ""
    const newColor = event.params.color || ""

    // kolor - wspólny dla obu typów
    if (svg) {
      if (oldColor) svg.classList.remove(...oldColor.split(" "))
      if (newColor) svg.classList.add(...newColor.split(" "))
    }

    const border = this.priorityTarget.querySelector(".priority-border")
    if (border) {
      // gwiazdka: tylko przełączenie obwódki (kształt bez zmian)
      if ((newColor.includes("full") && !oldColor.includes("full")) || (!newColor.includes("full") && oldColor.includes("full"))) {
        border.classList.toggle("hidden")
      }
    } else {
      // chevron: podmiana kształtu ścieżkami z klikniętej opcji
      const optionSvg = event.currentTarget.querySelector("svg")
      if (svg && optionSvg) svg.innerHTML = optionSvg.innerHTML
    }

    this.priorityTarget.dataset.currentColor = newColor

    if (this.hasInputTarget) this.inputTarget.value = event.params.value
  }
}
